import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import axios from "axios";
import Cookies from "js-cookie";
import { Redirect } from "react-router-dom";
import { Modal } from "antd";
import ServiceApi from "../../services/ServiceApi";
import { setOperation } from "../../actions/operationdataAction";
import Action from "../../actions/modulesAction";
import { Link } from "react-router-dom";
/* import { messaging } from "../../firebase"; */

const operatorMaster = new Map([
  [
    "UIH",
    {
      companyId: 3,
      companyName: "BBTEC",
      operatorId: 3,
      operatorName: "UIH",
    },
  ],
  [
    "DTAC",
    {
      companyId: 3,
      companyName: "BBTEC",
      operatorId: 4,
      operatorName: "DTAC",
    },
  ],
]);

const operatorBuild = operatorMaster.get(process.env.REACT_APP_BUILD_MODE);

class Login extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      form: {},
      userToken: "",
      redirect: 0,
      redirectPath: "",
      modal: null,
      modalMessage: null,
      errorDetail: "",
      submitting: 0,
      checkerror: false,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  CookiesChecker() {
    let redirectpath = !this.props.location
      .state /*|| (this.props.location.state.frompage) === '/MaxiOperation/login' */
      ? "/MaxiOperation/"
      : this.props.location.state.frompage;
    const moduleToken = Cookies.get("OperationToken");
    let identifier = {};
    if (moduleToken) {
      try {
        identifier = ServiceApi.post("tokenchecker", {
          TokenUser: moduleToken,
        });
      } catch (error) {
        identifier = error;
      }
      identifier.then((value) => {
        if (value.data.result.value === "P") {
          this.setState({
            redirectPath:
              redirectpath === "/" ? "/Maxioperation/" : redirectpath,
            redirect: this.props.location.pathname === "/" ? 1 : 0,
          });
        } else {
          this.setState({
            redirectPath: "/",
            redirect: this.props.location.pathname === "/" ? 0 : 1,
          });
        }
      });
    } else {
      this.setState({
        redirectPath: "/",
        redirect: this.props.location.pathname === "/" ? 0 : 1,
      });
    }
  }
  renderRedirect = () => {
    if (this.state.redirect) {
      return (
        <Redirect
          to={{
            pathname: this.state.redirectPath,
            state: { frompage: this.props.location.pathname },
          }}
        />
      );
    }
  };
  componentWillMount() {
    this.props.setModules([]);
    document.title = "MaxiOperation - Login";
    // this.CookiesChecker();
    // const data_from_dynamic = await Api.Get(
    //   "get_list_mas_form_json",
    //   "oper_job"
    // );
    // const period = await Api.Post("get_ma_period", {
    //   pk_id: "",
    //   is_active: "1",
    //   effective: "",
    //   sql_where: "",
    // });
    // const asset = await Api.Get("get_cdi_new_smart");
    // const job_cat_obj = await Api.Get("get_job_category");
    // const getBtn = await Api.Post("getButtonDetailWeb", {
    //   WF_ID: 0,
    //   CompanyID: 1,
    //   ProjectID: 1,
    //   JobTypeID: 1,
    //   Version: 1,
    //   MainProcessID: "0",
    //   SubProcessID: "-1",
    //   ActionID: 1,
    //   UserName: "tirapong_s",
    //   TokenUser: "63423fe4c6ff56e7e9b4fcb0c50cb3f386316931"
    // }, );
  }
  handleInputChange(event) {
    var name = event.target.name;
    var value = event.target.value;
    var form = this.state.form;
    if (name === "username") {
      form["UserName"] = value;
    }
    if (name === "password") {
      form["Password"] = value;
    }
  }
  toJson(jsonString) {
    let myJSONString = JSON.parse(JSON.stringify(jsonString.data.data));
    return JSON.parse(myJSONString);
  }
  handleSubmit = () => {
    const { form } = this.state;
    const { REACT_APP_URL_WF_API } = process.env;
    const url = `${REACT_APP_URL_WF_API}CheckUserAuthLogin`;
    this.setState({
      modal: 1,
      modalMessage: "Validate user ...",
      errorDetail: null,
    });
    var config = {
      method: "post",
      url: url,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        UserName: form.UserName,
        Password: form.Password,
        UserAuth: "maxi_wf_test",
        TokenAuth: "maxi@072020",
        CompanyID: null,
      },
    };
    axios
      .post(url, {
        UserName: form.UserName,
        Password: form.Password,
        UserAuth: "maxi_wf_test",
        TokenAuth: "maxi@072020",
        CompanyID: null,
      })
      .then((response) => {

        if (response.data?.result?.value === "P") {
          const operator = response.data.operData.find(
            (s) => s.operator_id === operatorBuild?.operatorId
          );

          const project = response.data.projectData.find(
            (s) => s.operator_id === operatorBuild?.operatorId
          );

          Cookies.set("OperationToken", response.data.data[0].token, {
            expires: 1,
          });
          Cookies.set(".MaxiLanguage", "EN", { expires: 1 });
          Cookies.set(".MaxiAuthToken", response.data.data[0].token, {
            expires: 1,
          });
          Cookies.set("MaxiToken", response.data.data[0].token, { expires: 1 });
          Cookies.set("userId", response.data.data[0].id, { expires: 1 });
          Cookies.set("username", form.UserName, { expires: 1 });
          Cookies.set("activeTab", 0, { expires: 1 });
          Cookies.set("fullName", response.data.data[0].full_Name, {
            expires: 1,
          });
          Cookies.set("companyid", response.data.data[0].company_id, {
            expires: 1,
          });
          Cookies.set("team_id", response.data.data[0].team_id, { expires: 1 });
          Cookies.set("usergroup_id", response.data.data[0].usergroup_id, {
            expires: 1,
          });
          Cookies.set("usergroupname", response.data.data[0].usergroup_name, {
            expires: 1,
          });

          if (project) {
            Cookies.set("project_id", project.project_id, {
              expires: 1,
            });
          } else {
            Cookies.set("project_id", response.data.projectData[0].project_id, {
              expires: 1,
            });
          }

          Cookies.set("logopath", response.data.data[0].company_logo_path, {
            expires: 1,
          });

          if (operator) {
            Cookies.set("operator_id", operator.operator_id, {
              expires: 1,
            });
            Cookies.set("operator_name", operator.operator_name, {
              expires: 1,
            });
          } else {
            Cookies.set("operator_id", response.data.operData[0].operator_id, {
              expires: 1,
            });
            Cookies.set(
              "operator_name",
              response.data.operData[0].operator_name,
              {
                expires: 1,
              }
            );
          }

          Cookies.set("plantCode", response.data.whData[0].plant, {
            expires: 1,
          });
          Cookies.set("storage", response.data.whData[0].sloc, {
            expires: 1,
          });
          Cookies.set("StockToken", response.data.data[0].token, {
            expires: 1,
          });

          Cookies.set("userITSM", response.data.data[0].userITSM, {
            expires: 1,
          });

          Cookies.set("locale", "en");
          localStorage.clear();
          localStorage.setItem(
            "operator",
            JSON.stringify(response.data.operData)
          );
          localStorage.setItem(
            "projectData",
            JSON.stringify(response.data.projectData)
          );
          localStorage.setItem(
            "companyData",
            JSON.stringify(response.data.companyData)
          );
          const checkPermission = response.data.data.filter(
            (data) => data.usergroup_name === "TL"
          );
          if (checkPermission.length > 0) {
            localStorage.setItem("checkPermission", 1);
          } else {
            localStorage.setItem("checkPermission", 0);
          }
          localStorage.setItem(
            "companyid",
            response.data.operData[0].company_id
          );
          localStorage.setItem(
            "project_id",
            response.data.projectData[0].project_id
          );
          localStorage.setItem(
            "operator_id",
            response.data.operData[0].operator_id
          );
          localStorage.setItem("data_list", JSON.stringify(response.data.data));

          if (parseInt(response.data.operData[0].company_id) !== 1) {
            Cookies.set(
              "userarea",
              response.data.data.reduce(
                (total, item) =>
                  total + `${item.work_center_list?.replace(/;/g, ",")},`,
                ""
              ),
              {
                expires: 1,
              }
            );
          }

          const [objData] = response.data.data;

          const modulesList = objData.system_name_list?.split(";").map((s) => {
            // const splitModules = s.split(":");
            // return { system_code: splitModules[0] };
            return { system_code: s };
          });
          this.props.setModules(modulesList);
          // this.setState({
          //   modal: 1,
          //   errorDetail: "",
          // });
          setTimeout(() => {
            if (parseInt(response.data.operData[0].company_id) === 3) {
              localStorage.setItem(
                "status_2fa",
                JSON.stringify(response.data.data[0].status_2fa)
              );
              // window.location.assign(ServiceApi.absoluteUrl("/authentication_2factor"));
              Cookies.set("authenCheck", "True", { expires: 1 });
              window.location.assign(ServiceApi.absoluteUrl("/SelectModules"));
              this.setState({ modal: 0,modalMessage: null });
            } else {
              window.location.assign(ServiceApi.absoluteUrl("/SelectModules"));
              this.setState({ modal: 0,modalMessage: null });
            }
          }, 1000);
          this.setState({
            submitting: 0,
          });
          // }
        } else {
          this.setState({
            modal: 1,
            modalMessage: null,
            errorDetail: "Please Check Username And Password !!! ",
          });
        }
      })
      .catch((error) => {
        console.log('error',error)
        this.setState({
          modal: 1,
          modalMessage: null,
          errorDetail: error.message,
        });
      });
  };
  isSubmit = (e) => {
    if (e.key === "Enter") {
      this.handleSubmit();
    }
  };
  modalClosed = () => {
    this.setState({
      modal: 0,
      modalMessage: null
    });
  };
  authen = async () => {
    try {
      const { REACT_APP_URL_WF_API } = process.env; //old login api
      /*     const success = await ServiceApi.post("maxilogin", { */ const success =
        axios.post(`${REACT_APP_URL_WF_API}CheckUserAuthLogin`, {
          UserName: this.state.form.UserName,
          Password: this.state.form.Password,
          UserAuth: "maxi_wf_test",
          TokenAuth: "maxi@072020",
          CompanyID: "",
        });
      return success;
    } catch (error) {
      return error;
    }
  };
  render() {
    return (
      <div className="container body-content">
        {/* {this.renderRedirect()} */}
        <Modal
          title={null}
          centered
          visible={this.state.modal}
          footer={null}
          closable={this.state.errorDetail ? true : false}
          maskClosable={this.state.errorDetail ? true : false}
          onCancel={this.modalClosed}
        >
          <div className="text-center">
            {!this.state.errorDetail ? (
              <img
                src={ServiceApi.absoluteUrl("/img/modal_approve.svg")}
                className="img-fluid"
                alt=""
              />
            ) : (
              <img
                src={ServiceApi.absoluteUrl("/img/login_error.png")}
                className="img-fluid"
                alt=""
              />
            )}

            <h3
              className={
                "font-mont-sb fs-18 mt-3" +
                (!this.state.errorDetail ? " c-blue" : " c-red")
              }
            >
              {this.state.modalMessage
                ? this.state.modalMessage
                : !this.state.errorDetail
                ? "Successfully Login"
                : "Failed"}
            </h3>
            {!this.state.errorDetail ? (
              <Fragment>
                {/* redirecting{" "} */}
                <div
                  className="spinner-border position-relative"
                  style={{
                    width: "2rem",
                    height: "2rem",
                    left: "0.5rem",
                    top: "0.5rem",
                    zIndex: 1001,
                  }}
                  role="status"
                >
                  <span className="sr-only">Loading...</span>
                </div>
              </Fragment>
            ) : (
              <Fragment>{this.state.errorDetail}</Fragment>
            )}
          </div>
        </Modal>
        <div className="background-100"></div>

        <div className="box-container">
          <div>
            <select defaultValue="EN" className="form-control chang-lgg">
              <option value="EN">EN</option>
              <option value="TH">TH</option>
            </select>
          </div>
          <div className="row">
            <div className="col-6 offset-md-1 mt-form-log">
              <div>
                <img
                  src={ServiceApi.absoluteUrl("/img/Group_278.png")}
                  alt=""
                />
              </div>
              <div className="row" style={{ marginTop: "45px" }}>
                {/* <div className="col-auto">
                  <div className="form-group">
                    <label
                      className="la-login-user f-mon"
                      style={{
                        fontSize: "12px",
                        margin: "0px",
                        color: " #333333",
                      }}
                    >
                      Username
                    </label>
                    </div>
                    </div> */}
                <div className="col-auto">
                  <div className="form-group">
                    <label
                      className="la-login-user f-mon"
                      style={{
                        fontSize: "12px",
                        margin: "0px",
                        color: " #333333",
                      }}
                    >
                      Username
                    </label>
                    <input
                      className="form-input-maxi in-login-user f-mon"
                      data-val="true"
                      placeholder="Please enter your username"
                      required="required"
                      style={{
                        backgroundColor: "#d9e4fc",
                        fontSize: "12px",
                        height: "40px",
                        width: "290px",
                      }}
                      type="text"
                      name="username"
                      onChange={this.handleInputChange}
                    />
                  </div>
                  <div
                    className="form-group"
                    style={{ marginTop: "5px !important", marginBottom: "5px" }}
                  >
                    <label
                      className="la-login-pw f-mon"
                      htmlFor="Password"
                      style={{
                        fontSize: "12px",
                        margin: "0px",
                        color: " #333333",
                      }}
                    >
                      Password
                    </label>
                    <input
                      className="form-input-maxi in-login-pw f-mon"
                      placeholder="Please enter your password"
                      required="required"
                      style={{
                        backgroundColor: "#d9e4fc",
                        fontSize: "12px",
                        height: "40px",
                        width: "290px",
                      }}
                      type="password"
                      name="password"
                      onChange={this.handleInputChange}
                      onKeyUp={this.isSubmit}
                    />
                  </div>
                  <div
                    className="d-flex"
                    style={{ justifyContent: "space-between" }}
                  >
                    <Link to="/change_password" className="fs-8 a-line">
                      CHANGE PASSWORD
                    </Link>
                    <Link to="/forget_password" className="fs-8 a-line">
                      FORGET PASSWORD
                    </Link>
                  </div>
                  <div
                    className="row justify-content-center"
                    style={{ marginTop: "30px" }}
                  >
                    <button
                      className="btn btn-block btn-login font-mon login-page"
                      style={
                        this.state.submitting === 0
                          ? {}
                          : { cursor: "not-allowed" }
                      }
                      disabled={this.state.submitting === 0 ? false : true}
                      onClick={this.handleSubmit}
                    >
                      {this.state.submitting === 0 ? (
                        "LogIn"
                      ) : (
                        <div
                          className="spinner-border position-relative"
                          style={{
                            width: "2rem",
                            height: "2rem",
                            color: "#fff",
                            zIndex: 1001,
                          }}
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      )}
                    </button>
                  </div>
                  <div className="row">
                    <div
                      className="f-mon alarm-login"
                      style={{
                        fontSize: "12px",
                        color: "red",
                        marginTop: "10px",
                        padding: "15px",
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-5" style={{ paddingRight: "0px" }}>
              <div className="d-flex flex-row-reverse" align="right">
                <div
                  className="login-image"
                  style={{ marginBottom: "-1px" }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  operation: state.operationReducer,
});
const mapDispacthToProps = (dispatch) => {
  return {
    setOperation: (data) => dispatch(setOperation(data)),
    setModules: (data) =>
      dispatch({ type: Action.SET_MODULES_LIST, payloads: data }),
  };
};

export default connect(mapStateToProps, mapDispacthToProps)(Login);
